export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ../~/_@ant-design_icons-react@2.0.1@@ant-design/icons-react/es/index.js
// module id = 305
// module chunks = 0